import { createContext, useState, ReactNode, useContext } from 'react';
import { useDashboard } from '../../context/context/DashboardContext';
import { useNegocioContext } from '../../context/context/DetalhamentoNegocioContext';
import { usePainelProcessamento } from '../../context/context/PainelProcessaementoContext';

interface HeaderFilterProviderProps {
  children: ReactNode;
}

interface HeaderFilterProps {
  filtroDataCredorDashboard(isCancelar: boolean, page: string): Promise<any>;
  setDataInicioHeader(value: string): void;
  setDataFimHeader(value: string): void;
  setFiltro(value: boolean): void;
  dataInicio: string;
  dataFim: string;
  filtrado: boolean;
  chamado: boolean;
  online: boolean;
  valorFiltros: ValorFiltrosProps;
}

interface ValorFiltrosProps {
  dataInicio: string;
  dataFim: string;
  credor: string;
}

const HeaderFilterContext = createContext<HeaderFilterProps>(
  {} as HeaderFilterProps,
);

export const HeaderFilterProvider = ({
  children,
}: HeaderFilterProviderProps) => {
  const [dataInicio, setDataInicio] = useState(
    new Date().toLocaleDateString().split('/').reverse().join('-'),
  );
  const [dataFim, setDataFim] = useState(
    new Date().toLocaleDateString().split('/').reverse().join('-'),
  );
  const [filtrado, setFiltrado] = useState(false);
  const [chamado, setChamado] = useState(false);
  const [online, setOnline] = useState(false);

  const { getDashboardData, rankingEstados } = useDashboard();
  const { getNegocio } = useNegocioContext();
  const { getLogs } = usePainelProcessamento();

  // const { selectedCredorOption, onOptionSelected } = useSelectComponent();
  const [valorFiltros, setValorFiltros] = useState<ValorFiltrosProps>({
    dataInicio,
    dataFim,
    credor: '',
  });

  function setDataInicioHeader(value: string) {
    setDataInicio(value);
  }

  function setDataFimHeader(value: string) {
    setDataFim(value);
  }

  async function filtroDataCredorDashboard(isCancelar: boolean, page: string) {
    const currentCredor = JSON.parse(localStorage.getItem('currentCompany')!);
    setChamado(true);

    if (isCancelar) {
      setDataInicioHeader(
        new Date().toLocaleDateString().split('/').reverse().join('-'),
      );
      setDataFimHeader(
        new Date().toLocaleDateString().split('/').reverse().join('-'),
      );
      // onOptionSelected('Todos', true);

      setValorFiltros({
        dataInicio: new Date()
          .toLocaleDateString()
          .split('/')
          .reverse()
          .join('-'),
        dataFim: new Date().toLocaleDateString().split('/').reverse().join('-'),
        credor: currentCredor.credor_infos.credor_crm,
      });

      if (page === 'dashboard') {
        await getDashboardData(
          new Date().toLocaleDateString().split('/').reverse().join('-'),
          new Date().toLocaleDateString().split('/').reverse().join('-'),
        );
      } else if (page === 'detailing') {
        await getNegocio(
          new Date().toLocaleDateString().split('/').reverse().join('-'),
          new Date().toLocaleDateString().split('/').reverse().join('-'),
          currentCredor.credor_infos.credor_crm,
        );
      } else if (page === 'estadosInfo') {
      } else if (page === 'negocio') {
        await getNegocio(
          new Date().toLocaleDateString().split('/').reverse().join('-'),
          new Date().toLocaleDateString().split('/').reverse().join('-'),
        );
      } else if (page === 'processamento') {
        await getLogs({
          dataInicio: new Date()
            .toLocaleDateString()
            .split('/')
            .reverse()
            .join('-'),
          dataFim: new Date()
            .toLocaleDateString()
            .split('/')
            .reverse()
            .join('-'),
        });
      }

      setChamado(false);
    } else {
      setValorFiltros({
        dataInicio,
        dataFim,
        credor: currentCredor.credor_infos.credor_crm,
      });

      if (page === 'dashboard') {
        await getDashboardData(
          dataInicio,
          dataFim,
          currentCredor.credor_infos.credor_crm,
        );

        if (
          dataFim ===
          new Date().toLocaleDateString().split('/').reverse().join('-')
        ) {
          setOnline(true);
        } else {
          setOnline(false);
        }
      } else if (page === 'estadosInfo') {
        await rankingEstados(
          dataInicio,
          dataFim,
          currentCredor.credor_infos.credor_crm,
        );
      } else if (page === 'negocio') {
        await getNegocio(
          dataInicio,
          dataFim,
          currentCredor.credor_infos.credor_crm,
        );
      } else if (page === 'processamento') {
        await getLogs({
          dataInicio,
          dataFim,
        });
      }

      setChamado(false);
    }
  }

  function setFiltro(value: boolean) {
    setFiltrado(value);
  }

  return (
    <HeaderFilterContext.Provider
      value={{
        dataInicio,
        dataFim,
        setDataFimHeader,
        setDataInicioHeader,
        filtroDataCredorDashboard,
        filtrado,
        setFiltro,
        chamado,
        valorFiltros,
        online,
      }}
    >
      {children}
    </HeaderFilterContext.Provider>
  );
};

export const useHeaderFilter = () => useContext(HeaderFilterContext);
